// extracted by mini-css-extract-plugin
module.exports = {"title":"Accueil_title__18VU5","disabled":"Accueil_disabled__b6D6a"};